import type { ReactNode } from 'react';

import { cn } from '@shigo-ui/ui/cn';

export interface DashboardPageMetadataItemProps {
  label: ReactNode;
  value: ReactNode;
  icon?: ReactNode | undefined;
  className?: string | undefined;
}

export function DashboardPageMetadataItem({
  label,
  value,
  icon,
  className,
}: DashboardPageMetadataItemProps) {
  return (
    <dl
      data-slot="dashboard-page-metadata-item"
      className={cn(
        'flex max-w-full min-w-0 items-center gap-2.5 self-start sm:flex-none',
        className,
      )}
    >
      {icon ? (
        <div className="border-border bg-background text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-md border">
          {icon}
        </div>
      ) : null}
      <div className="min-w-0">
        <dt className="text-muted-foreground text-[11px] leading-4 font-medium [overflow-wrap:anywhere]">
          {label}
        </dt>
        <dd className="text-foreground min-w-0 truncate text-sm leading-5 font-semibold">
          {value}
        </dd>
      </div>
    </dl>
  );
}
